export default __webpack_public_path__ + "static/media/full screen_hover_toggle.a07b38ab.svg";